/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome, Firefox, Edge, etc.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// CoreJS polyfills for modern browsers
import 'core-js/stable'; // Inclui todos os polyfills estáveis necessários

// Zone.js required by Angular
import 'zone.js'; // Inclui zone.js para Angular

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// Adicione polyfills específicos apenas se necessário para seu caso
// Exemplo: se você suporta navegadores muito antigos como IE11 (não recomendado para Angular 16)
